import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/license.statuses.query.gql"
import type {
  LicenseStatusesQuery,
  LicenseStatusesQueryVariables,
} from "@/v2-backoffice-client/license/__types__/license.statuses.query"

type Options = QueryHookOptions<
  LicenseStatusesQuery,
  LicenseStatusesQueryVariables
>

export function useLicenseStatusesQuery(options?: Options) {
  return useQuery<LicenseStatusesQuery, LicenseStatusesQueryVariables>(
    query,
    options,
  )
}
